export default __webpack_public_path__ + "static/media/solidstar.07305ff4.svg";